const EU_COUNTRIES = ['at', 'be', 'bg', 'hr', 'cy', 'cz', 'dk', 'ee', 'fi', 'fr', 'de', 'gr', 'hu', 'ie', 'it', 'lv', 'lt', 'lu', 'mt', 'nl', 'pl', 'pt', 'ro', 'sk', 'si', 'es', 'se'];
const COUNTRY_SYNONYMS = { gb: ['uk'], uk: ['gb'] };
const LOCATION_CODES = ['us', 'eu', 'uk', 'gb', 'au', 'ca', 'at', 'de', 'hu', 'be', 'fr', 'hr', 'fi', 'gr', 'it', 'pl', 'bg', 'dk', 'ie', 'cy', 'nl', 'ro', 'ee', 'is', 'pt', 'lt', 'es'];
const isGeoEnabled = () => !(typeof window !== 'undefined' && window.enableGeoFilter === false);
if (!isGeoEnabled()) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showAllProducts);
  } else {
    showAllProducts();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!isGeoEnabled()) {
    showAllProducts();
    return;
  }
  const existingCountry = getCookie('user_country');
  if (existingCountry) {
    setTimeout(() => {
      filterProductsByLocation(existingCountry);
    }, 100);
    return;
  }
  fetch('https://ipinfo.io?token=59ad9e87f8cf78')
    .then(response => response.json())
    .then(data => {
      const userCountry = data.country.toLowerCase();
      document.cookie = "user_country=" + userCountry + ";path=/";
      setTimeout(() => {
        filterProductsByLocation(userCountry);
      }, 100);
    })
    .catch(err => {
      console.error('Error fetching IP:', err);
      showAllProducts();
    });
});

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function showAllProducts() {
    const collectionItems = document.querySelectorAll('.collection-product-item');
    
    collectionItems.forEach(item => {
        item.style.display = '';
        item.style.visibility = 'visible';
        item.style.opacity = '1';
    });

    const itemsPDP = document.querySelectorAll('[data-section-type="product"]');
    if (itemsPDP.length > 0) {
        itemsPDP.forEach(item => {
            item.style.display = 'block';
            item.style.opacity = '1';
            item.style.height = '100%';
        });
    }
    
    const noProductsMessage = document.querySelector('#no-products-message');
    if (noProductsMessage) {
        noProductsMessage.style.display = 'none';
    }

    const loader = document.querySelector('#loading-svg-repo');
    if (loader) {
        loader.style.display = 'none';
    }
}

function filterProductsByLocation(userCountry) {
    let anyVisibleCollection = false;
    let anyVisiblePDP = false;

    const collectionItems = document.querySelectorAll('.collection-product-item');
    
    if (collectionItems.length > 0) {
        const locationAttributes = LOCATION_CODES;
        const allowed = new Set([userCountry, ...(COUNTRY_SYNONYMS[userCountry] || [])]);
        
        collectionItems.forEach(item => {
            let showItem = false;
            let hasAnyGeoAttribute = false;
            
            locationAttributes.forEach(location => {
                const attrValue = item.getAttribute(`data-geo-location-${location}`);
                
                if (attrValue === 'true') {
                    hasAnyGeoAttribute = true;
                    
                    if (allowed.has(location)) {
                        showItem = true;
                    }
                    
                    if (location === 'eu' && EU_COUNTRIES.includes(userCountry)) {
                        showItem = true;
                    }
                }
            });

            if (!hasAnyGeoAttribute) {
                showItem = true;
            }

            if (showItem) {
                item.style.display = '';
                item.style.visibility = 'visible';
                item.style.opacity = '1';
                anyVisibleCollection = true;
            } else {
                item.style.display = 'none';
            }
        });

        const noProductsMessage = document.querySelector('#no-products-message');
        if (noProductsMessage) {
            noProductsMessage.style.display = anyVisibleCollection ? 'none' : 'flex';
        }
    }

    const itemsPDP = document.querySelectorAll('[data-section-type="product"]');

    if (itemsPDP.length > 0) {
        const locationAttributes = LOCATION_CODES;
        const allowed = new Set([userCountry, ...(COUNTRY_SYNONYMS[userCountry] || [])]);
        
        itemsPDP.forEach(item => {
            let loader = document.querySelector('#loading-svg-repo');
            let showItem = false;
            let hasAnyGeoAttribute = false;

            locationAttributes.forEach(location => {
                const attributeValue = item.getAttribute(`data-geo-location-${location}`);
                if (attributeValue === 'true') {
                    hasAnyGeoAttribute = true;
                    
                    if (allowed.has(location)) {
                        showItem = true;
                    }
                    
                    if (location === 'eu' && EU_COUNTRIES.includes(userCountry)) {
                        showItem = true;
                    }
                }
            });

            if (!hasAnyGeoAttribute) {
                showItem = true;
            }

            if (showItem) {
                item.style.display = 'block';
                item.style.opacity = '1';
                item.style.height = '100%';
                anyVisiblePDP = true;
                if (loader) {
                    loader.style.display = 'none';
                }
            } else {
                item.style.display = 'none';
            }
        });

        const noProductsMessage = document.querySelector('#no-products-message');
        if (noProductsMessage) {
            noProductsMessage.style.display = anyVisiblePDP ? 'none' : 'flex';
            const loader = document.querySelector('#loading-svg-repo');
            if (loader) {
                loader.style.display = anyVisiblePDP ? 'none' : 'flex';
            }
        }
    }
}

window.onload = () => {
    let collectionGrid = document.querySelector(".collection");
    if (collectionGrid) {
        collectionGrid.style.opacity = 1;
    }

    let itemProduct = document.querySelector('[data-section-type="product"]');
    if (itemProduct) {
      itemProduct.style.opacity = '1';
      itemProduct.style.height = '100%';
    }

    const userCountry = getCookie('user_country');
    if (isGeoEnabled() && userCountry) {
        filterProductsByLocation(userCountry);
    } else if (!isGeoEnabled()) {
        showAllProducts();
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        const userCountry = getCookie('user_country');
        if (isGeoEnabled() && userCountry) {
            setTimeout(() => {
                filterProductsByLocation(userCountry);
            }, 200);
        } else if (!isGeoEnabled()) {
            showAllProducts();
        }
    });
}
